<template>
  <CellGroup>
    <Cell v-for="item in labelList" :key="item.label" :title="item.label">
      <div class="label_extra" slot="extra">{{item.value}}</div>
    </Cell>
  </CellGroup>
</template>

<script>
export default {
  components: {},
  props: {
    initdata: {
      type: [Object, Array],
      default() {
        return {
          label: "标题",
          value: "内容"
        };
      },

      validator(val) {
        if (val.label === undefined || val.value === undefined) {
          console.error("filter_label组件 需要对象包含label和value属性");
          return false;
        }
        return true;
      }
    }
  },

  data() {
    return {
      labelList: []
    };
  },

  watch: {
    initdata: {
      handler(newVal, oldVal) {
        // 如果传入的是对象，将传入值转为数组
        // 如果是数组直接赋值
        if (this._.isObject(newVal)) {
          this.labelList.splice(0, 1, newVal);
        } else {
          this.labelList = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.label_extra {
  color: #f44241;
  font-size: 18px;
}
</style>
